import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ab559d74"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "auto-assist-form__container"
};
var _hoisted_2 = {
  "class": "auto-assist-form__container-contents"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "Confirm Phone Number", -1);
});
var _hoisted_5 = {
  "class": "flex-child"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label"
  }, "Phone Number Confirmed", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "for": "confirmedPhoneNumber",
    "class": "styled-label"
  }, null, -1);
});
var _hoisted_8 = {
  "class": "form__button-container"
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", {
    "class": "form__title"
  }, "User Information", -1);
});
var _hoisted_11 = {
  "class": "flex-child"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "schedulingOnBehalfOf"
  }, "Scheduling On Behalf Of", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("option", {
    value: "Myself",
    selected: ""
  }, "Myself", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("option", {
    value: "other"
  }, "Other", -1);
});
var _hoisted_15 = [_hoisted_13, _hoisted_14];
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "styled-checkbox form__input-label",
    "for": "schedulingRelationship"
  }, null, -1);
});
var _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-ab559d74>Select Relationship</option><option value=\"Spouse\" data-v-ab559d74>Spouse</option><option value=\"Signifigant Other\" data-v-ab559d74>Signifigant Other</option><option value=\"Child\" data-v-ab559d74>Child</option><option value=\"Parent\" data-v-ab559d74>Parent</option><option value=\"Friend\" data-v-ab559d74>Friend</option><option value=\"Other\" data-v-ab559d74>Other</option>", 7);
var _hoisted_25 = [_hoisted_18];
var _hoisted_26 = {
  "class": "flex-parent"
};
var _hoisted_27 = {
  key: 0,
  "class": "flex-child flex-child-lg"
};
var _hoisted_28 = {
  "class": "form__input-label",
  "for": "behalfOfFirstName"
};
var _hoisted_29 = ["placeholder"];
var _hoisted_30 = {
  key: 1,
  "class": "flex-child flex-child-lg"
};
var _hoisted_31 = {
  "class": "form__input-label",
  "for": "behalfOfLastName"
};
var _hoisted_32 = ["placeholder"];
var _hoisted_33 = {
  "class": "flex-parent flex-child-lg"
};
var _hoisted_34 = {
  "class": "flex-child"
};
var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userFirstName"
  }, "My First Name", -1);
});
var _hoisted_36 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userLastName"
  }, "My Last Name", -1);
});
var _hoisted_38 = {
  "class": "flex-parent"
};
var _hoisted_39 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userPhoneCountryCode"
  }, "Country", -1);
});
var _hoisted_41 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userPhoneAreaCode"
  }, "Area", -1);
});
var _hoisted_43 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userPhone2"
  }, "Phone", -1);
});
var _hoisted_45 = {
  "class": "flex-parent"
};
var _hoisted_46 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userAddress"
  }, "Address", -1);
});
var _hoisted_48 = {
  "class": "flex-parent"
};
var _hoisted_49 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userCity"
  }, "My City", -1);
});
var _hoisted_51 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userState"
  }, "My State", -1);
});
var _hoisted_53 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_54 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "userZip"
  }, "Zip Code", -1);
});
var _hoisted_55 = {
  "class": "form__button-container"
};
var _hoisted_56 = {
  key: 2
};
var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "Business Information", -1);
});
var _hoisted_58 = {
  "class": "description"
};
var _hoisted_59 = ["href"];
var _hoisted_60 = {
  "class": "description",
  style: {
    "margin-top": "10px",
    "margin-bottom": "20px"
  }
};
var _hoisted_61 = ["href"];
var _hoisted_62 = {
  "class": "form_toggle-container"
};
var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("b", null, "Save Locally"), /*#__PURE__*/_createTextVNode(" Saves information for later use on "), /*#__PURE__*/_createElementVNode("i", null, "this device only")], -1);
});
var _hoisted_64 = {
  "class": "form_toggle-container"
};
var _hoisted_65 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "Save to cloud", -1);
});
var _hoisted_66 = {
  "class": "flex-parent"
};
var _hoisted_67 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_68 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "businessName"
  }, "Business Name", -1);
});
var _hoisted_69 = {
  "class": "flex-parent"
};
var _hoisted_70 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_71 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "businessAddress"
  }, "Business Address", -1);
});
var _hoisted_72 = {
  "class": "flex-parent"
};
var _hoisted_73 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_74 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "businessCity"
  }, "Business City", -1);
});
var _hoisted_75 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_76 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "businessState"
  }, "Business State", -1);
});
var _hoisted_77 = {
  "class": "flex-parent"
};
var _hoisted_78 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_79 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "businessPhone"
  }, "Business Phone", -1);
});
var _hoisted_80 = {
  "class": "flex-child flex-child-md"
};
var _hoisted_81 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form__input-label",
    "for": "schedulingType"
  }, "Scheduling Type", -1);
});
var _hoisted_82 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("option", {
    value: ""
  }, "Select Scheduling Type", -1);
});
var _hoisted_83 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("option", {
    value: "Appointment"
  }, "Appointment", -1);
});
var _hoisted_84 = [_hoisted_82, _hoisted_83];
var _hoisted_85 = {
  "class": "form__button-container",
  style: {
    "margin-top": "20px"
  }
};
var _hoisted_86 = {
  key: 3
};
var _hoisted_87 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "Date and Times", -1);
});
var _hoisted_88 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "description"
  }, "Select one or more date and times that you want the the system to use to try and schedule your appointment. When speaking with the business, A.I. will try to find overlaps between your availability and theirs to find the best preference. The first entry will used as your first preference, the second as the second and so on.", -1);
});
var _hoisted_89 = {
  "class": "preference__top"
};
var _hoisted_90 = {
  key: 0,
  "class": "preference__message"
};
var _hoisted_91 = {
  "class": "preference__date"
};
var _hoisted_92 = {
  key: 0,
  "class": "preference__time"
};
var _hoisted_93 = {
  key: 1,
  "class": "preference__time"
};
var _hoisted_94 = {
  "class": "preference__selector"
};
var _hoisted_95 = {
  "class": "flex-parent"
};
var _hoisted_96 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_97 = {
  "class": "flex-parent"
};
var _hoisted_98 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_99 = {
  "class": "form_toggle-container"
};
var _hoisted_100 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "Anytime during business hours", -1);
});
var _hoisted_101 = {
  "class": "flex-parent"
};
var _hoisted_102 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_103 = ["disabled"];
var _hoisted_104 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_105 = ["disabled"];
var _hoisted_106 = {
  "class": "flex-parent"
};
var _hoisted_107 = {
  "class": "flex-child flex-child-sm"
};
var _hoisted_108 = {
  "class": "form__button-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  var _component_ToggleComponent = _resolveComponent("ToggleComponent");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.section === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _withDirectives(_createElementVNode("input", {
    placeholder: "Something",
    "class": "styled-checkbox form__checkbox",
    type: "checkbox",
    id: "confirmedPhoneNumber",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.confirmedPhoneNumber = $event;
    })
  }, null, 512), [[_vModelCheckbox, $data.confirmedPhoneNumber]]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-right",
    type: "button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.section = 2;
    }),
    label: "Next"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-right"
      })];
    }),
    _: 1
  })])])) : _createCommentVNode("", true), $data.section === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_hoisted_12, _withDirectives(_createElementVNode("select", {
    "class": "form__input form__input-small",
    id: "schedulingOnBehalfOf",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.schedulingOnBehalfOf = $event;
    })
  }, _hoisted_15, 512), [[_vModelSelect, $data.schedulingOnBehalfOf]])]), $data.schedulingOnBehalfOf === 'other' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _withDirectives(_createElementVNode("select", {
    placeholder: "Select Relationship",
    id: "schedulingRelationship",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.schedulingRelationship = $event;
    })
  }, _hoisted_25, 512), [[_vModelSelect, $data.schedulingRelationship]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [$data.schedulingOnBehalfOf === 'other' && $data.schedulingRelationship ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("label", _hoisted_28, _toDisplayString($data.schedulingRelationship) + "'s First Name", 1), _withDirectives(_createElementVNode("input", {
    placeholder: "".concat($data.schedulingRelationship, " First Name"),
    "class": "form__input",
    type: "text",
    id: "behalfOfFirstName",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.behalfOfFirstName = $event;
    })
  }, null, 8, _hoisted_29), [[_vModelText, _ctx.behalfOfFirstName]])])) : _createCommentVNode("", true), $data.schedulingOnBehalfOf === 'other' && $data.schedulingRelationship ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("label", _hoisted_31, _toDisplayString($data.schedulingRelationship) + "'s Last Name", 1), _withDirectives(_createElementVNode("input", {
    placeholder: "".concat($data.schedulingRelationship, " Last Name"),
    "class": "form__input",
    type: "text",
    id: "behalfOfLastName",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.behalfOfLastName = $event;
    })
  }, null, 8, _hoisted_32), [[_vModelText, $data.behalfOfLastName]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _withDirectives(_createElementVNode("input", {
    placeholder: "John",
    "class": "form__input",
    type: "text",
    id: "userFirstName",
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.userFirstName = $event;
    })
  }, null, 512), [[_vModelText, $data.userFirstName]])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _withDirectives(_createElementVNode("input", {
    placeholder: "Doe",
    "class": "form__input",
    type: "text",
    id: "userLastName",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.userLastName = $event;
    })
  }, null, 512), [[_vModelText, $data.userLastName]])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _withDirectives(_createElementVNode("input", {
    placeholder: "+1",
    "class": "form__input form__input-digit",
    type: "text",
    id: "userPhoneCountryCode",
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.userPhoneCountryCode = $event;
    })
  }, null, 512), [[_vModelText, $data.userPhoneCountryCode]])]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _withDirectives(_createElementVNode("input", {
    placeholder: "(123)",
    "class": "form__input form__input-digits",
    type: "text",
    id: "userPhoneAreaCode",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.userPhoneAreaCode = $event;
    })
  }, null, 512), [[_vModelText, $data.userPhoneAreaCode]]), _createTextVNode(" - ")]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _withDirectives(_createElementVNode("input", {
    placeholder: "468-4687",
    "class": "form__input form__input-digit",
    type: "text",
    id: "userPhone2",
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.userPhone2 = $event;
    })
  }, null, 512), [[_vModelText, $data.userPhone2]])])]), _createTextVNode("Myself "), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_hoisted_47, _withDirectives(_createElementVNode("input", {
    placeholder: "832 Main",
    "class": "form__input form__input-large",
    type: "text",
    id: "userAddress",
    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
      return $data.userAddress = $event;
    })
  }, null, 512), [[_vModelText, $data.userAddress]])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _withDirectives(_createElementVNode("input", {
    placeholder: "City",
    "class": "form__input",
    type: "text",
    id: "userCity",
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.userCity = $event;
    })
  }, null, 512), [[_vModelText, $data.userCity]])]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _withDirectives(_createElementVNode("input", {
    placeholder: "State",
    "class": "form__input",
    type: "text",
    id: "userState",
    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
      return $data.userState = $event;
    })
  }, null, 512), [[_vModelText, $data.userState]])]), _createElementVNode("div", _hoisted_53, [_hoisted_54, _withDirectives(_createElementVNode("input", {
    placeholder: "Zipcode",
    "class": "form__input",
    type: "text",
    id: "userZip",
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.userZip = $event;
    })
  }, null, 512), [[_vModelText, $data.userZip]])])]), _createElementVNode("div", _hoisted_55, [_createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-left",
    type: "button",
    onClick: _cache[15] || (_cache[15] = function ($event) {
      return $data.section = 3;
    }),
    label: "Previous"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-left",
        style: {
          "position": "absolute",
          "left": "10px",
          "top": "12px"
        }
      })];
    }),
    _: 1
  }), _createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-right",
    type: "submit",
    label: "Automate Call",
    style: {
      "background": "lime",
      "color": "black",
      "border": "2px solid lime",
      "position": "relative",
      "padding-right": "40px",
      "padding-left": "10px"
    }
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-gears",
        style: {
          "position": "absolute",
          "right": "5px",
          "top": "12px",
          "color": "black"
        }
      })];
    }),
    _: 1
  })])])) : _createCommentVNode("", true), $data.section === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, [_createTextVNode("Select the business you'd like for us to call on your behalf by using this system you agree to the "), _createElementVNode("b", null, [_createElementVNode("a", {
    href: "".concat(_ctx.$store.state.website, "/terms")
  }, "Terms of Service", 8, _hoisted_59)]), _createTextVNode(" related to using this service.")]), _createElementVNode("div", _hoisted_60, [_createTextVNode("Please be advised of the "), _createElementVNode("b", null, [_createElementVNode("a", {
    href: "https://".concat(_ctx.$store.state.website, "/pricing")
  }, "Usage Pricing", 8, _hoisted_61)]), _createTextVNode(" related to this service before using it.")]), _createElementVNode("div", _hoisted_62, [_createVNode(_component_ToggleComponent, {
    onClick: _cache[16] || (_cache[16] = function ($event) {
      return $data.saveUserInformationLocally = !$data.saveUserInformationLocally;
    }),
    active: $data.saveUserInformationLocally === true
  }, null, 8, ["active"]), _hoisted_63]), _createElementVNode("div", _hoisted_64, [_createVNode(_component_ToggleComponent, {
    onClick: _cache[17] || (_cache[17] = function ($event) {
      return $data.saveUserInformationCloud = !$data.saveUserInformationCloud;
    }),
    active: $data.saveUserInformationCloud === true
  }, null, 8, ["active"]), _createElementVNode("p", null, [_hoisted_65, _createTextVNode(" Information available on all devices you use " + _toDisplayString(_ctx.$store.state.appName) + " on", 1)])]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _withDirectives(_createElementVNode("input", {
    placeholder: "Office Name",
    "class": "form__input form__input-lg",
    type: "text",
    id: "businessName",
    "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
      return $data.businessName = $event;
    })
  }, null, 512), [[_vModelText, $data.businessName]])])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_hoisted_71, _withDirectives(_createElementVNode("input", {
    placeholder: "123 main street",
    "class": "form__input",
    type: "text",
    id: "businessAddress",
    "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
      return $data.businessAddress = $event;
    })
  }, null, 512), [[_vModelText, $data.businessAddress]])])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _withDirectives(_createElementVNode("input", {
    placeholder: "City",
    type: "text",
    id: "businessCity",
    "class": "form__input",
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return $data.businessCity = $event;
    })
  }, null, 512), [[_vModelText, $data.businessCity]])]), _createElementVNode("div", _hoisted_75, [_hoisted_76, _withDirectives(_createElementVNode("input", {
    placeholder: "State",
    type: "text",
    id: "businessState",
    "class": "form__input",
    "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
      return $data.businessState = $event;
    })
  }, null, 512), [[_vModelText, $data.businessState]])])]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_hoisted_79, _withDirectives(_createElementVNode("input", {
    placeholder: "+1 (123) 456-7890",
    type: "text",
    id: "businessPhone",
    "class": "form__input",
    "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
      return $data.businessPhone = $event;
    })
  }, null, 512), [[_vModelText, $data.businessPhone]])]), _createElementVNode("div", _hoisted_80, [_hoisted_81, _withDirectives(_createElementVNode("select", {
    id: "schedulingType",
    "class": "form__input",
    "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
      return $data.schedulingType = $event;
    }),
    disabled: ""
  }, _hoisted_84, 512), [[_vModelSelect, $data.schedulingType]])])]), _createElementVNode("div", _hoisted_85, [_createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-left",
    type: "button",
    onClick: _cache[24] || (_cache[24] = function ($event) {
      return $data.section = 1;
    }),
    label: "Previous"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-left",
        style: {
          "position": "absolute",
          "left": "10px",
          "top": "12px"
        }
      })];
    }),
    _: 1
  }), _createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-right",
    type: "button",
    onClick: _cache[25] || (_cache[25] = function ($event) {
      return $data.section = 3;
    }),
    label: "Next"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-right",
        style: {
          "position": "absolute",
          "right": "10px",
          "top": "12px"
        }
      })];
    }),
    _: 1
  })])])) : _createCommentVNode("", true), $data.section === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_hoisted_87, _hoisted_88, _createElementVNode("div", _hoisted_89, [$data.schedulingPreferences.length < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_90, "Please Add your first date and time preference for your appointment.")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.schedulingPreferences, function (preference, index) {
    return _openBlock(), _createElementBlock("div", {
      "class": "preference__container",
      key: index
    }, [_createElementVNode("div", _hoisted_91, _toDisplayString(preference.date), 1), _createVNode(_component_font_awesome_icon, {
      "class": "preference__icon",
      icon: "fa-trash-alt",
      onClick: function onClick($event) {
        return $options.removeItemFromSchedulingPreferences(index);
      }
    }, null, 8, ["onClick"]), !preference.allDay ? (_openBlock(), _createElementBlock("div", _hoisted_92, "Between " + _toDisplayString(preference.time) + " to " + _toDisplayString(preference.time2), 1)) : _createCommentVNode("", true), preference.allDay ? (_openBlock(), _createElementBlock("div", _hoisted_93, "Anytime during business hours")) : _createCommentVNode("", true)]);
  }), 128))]), _createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_withDirectives(_createElementVNode("input", {
    type: "date",
    "class": "form__input",
    "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
      return $data.preferenceDate = $event;
    }),
    onClick: _cache[27] || (_cache[27] = function () {
      return $options.openCalendar && $options.openCalendar.apply($options, arguments);
    }),
    ref: "calendarBtn"
  }, null, 512), [[_vModelText, $data.preferenceDate]])])]), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createVNode(_component_ToggleComponent, {
    onClick: _cache[28] || (_cache[28] = function ($event) {
      return $data.preferenceTimeAllDay = !$data.preferenceTimeAllDay;
    }),
    active: $data.preferenceTimeAllDay === true
  }, null, 8, ["active"]), _hoisted_100])])]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("b", {
    "class": _normalizeClass({
      'disabled': $data.preferenceTimeAllDay
    })
  }, "Between", 2), _withDirectives(_createElementVNode("input", {
    type: "time",
    "class": "form__input",
    "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
      return $data.preferenceTime = $event;
    }),
    disabled: $data.preferenceTimeAllDay
  }, null, 8, _hoisted_103), [[_vModelText, $data.preferenceTime]])]), _createElementVNode("div", _hoisted_104, [_createElementVNode("b", {
    "class": _normalizeClass({
      'disabled': $data.preferenceTimeAllDay
    })
  }, "To", 2), _withDirectives(_createElementVNode("input", {
    type: "time",
    "class": "form__input",
    disabled: $data.preferenceTimeAllDay,
    "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) {
      return $data.preferenceTime2 = $event;
    })
  }, null, 8, _hoisted_105), [[_vModelText, $data.preferenceTime2]])])]), _createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, [_createVNode(_component_ButtonBasic, {
    "class": "form__button",
    style: {
      "margin": "0 auto",
      "max-width": "400px",
      "background": "white",
      "border": "2px solid royalblue",
      "color": "black",
      "margin-top": "30px",
      "width": "90vw",
      "transform": "translateX(0%)",
      "left": "0%",
      "margin-bottom": "20px"
    },
    type: "button",
    onClick: _cache[31] || (_cache[31] = function ($event) {
      return $options.addSchedule();
    }),
    label: "Add Scheduling Preference"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-plus"
      })];
    }),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_108, [_createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-left",
    type: "button",
    onClick: _cache[32] || (_cache[32] = function ($event) {
      return $data.section = 2;
    }),
    label: "Previous"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-left",
        style: {
          "position": "absolute",
          "left": "10px",
          "top": "12px"
        }
      })];
    }),
    _: 1
  }), _createVNode(_component_ButtonBasic, {
    "class": "form__button form__button-right",
    type: "button",
    onClick: _cache[33] || (_cache[33] = function ($event) {
      return $data.section = 4;
    }),
    label: "Next"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: "fa-chevron-right",
        style: {
          "position": "absolute",
          "right": "10px",
          "top": "12px"
        }
      })];
    }),
    _: 1
  })])])) : _createCommentVNode("", true)])]);
}